import React from "react";
import PropTypes from "prop-types";
import { Stack, TextField } from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import useStyles from "./formStyles";

const TextFieldRenderer = ({
  label,
  name,
  onChange,
  disabled,
  value,
  error = "",
  placeholder,
  type = "text",
  min,
  max,
  maxLength,
  startAdornment,
  endAdornment,
  isFromGeolocation,
  ...rest
}) => {
  const styles = useStyles();

  return (
    <Stack direction="column" spacing={0.5} sx={{ width: "100%" }}>
      <span className={styles.label}>
        {label && label.trim() !== "" ? label : "\u00A0"}
      </span>
      {name === "mobile" ? (
        <MuiTelInput
          disabled={disabled}
          defaultCountry="GR"
          onlyCountries={["GR", "CY"]}
          value={value}
          onChange={(newValue) =>
            onChange({ target: { name, value: newValue } })
          }
          error={!!error}
          helperText={error}
          fullWidth
          size="small"
          variant="outlined"
          InputProps={{
            disableunderline: "true",
            variant: "outlined",
            classes: { notchedOutline: styles.input },
            style: { height: "40px" },
            ref: rest?.InputProps?.ref,
          }}
        />
      ) : (
        <TextField
          {...rest}
          name={name}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              "& fieldset": {
                borderColor: styles.input.borderColor,
              },
              "&:hover fieldset": {
                borderColor: styles.input.borderColor,
              },
              "&.Mui-focused fieldset": {
                borderColor: styles.input.borderColor,
              },
            },
            "& .MuiOutlinedInput-input": {
              paddingBottom: "22px",
            },
          }}
          slotProps={{
            htmlInput: {
              ref: rest?.inputProps?.ref,
              onChange: rest?.inputProps?.onChange,
              style: { height: "40px", paddingBottom: "18px" },
              min,
              max,
              maxLength,
            },
            input: {
              ref: rest?.InputProps?.ref,
              style: { height: "40px" },
              startAdornment,
              endAdornment,
              autoComplete: rest?.autoComplete || "on",
            },
            formHelperText: {
              className: isFromGeolocation
                ? styles.helperLocationText
                : styles.helperText,
            },
          }}
          onChange={onChange}
          type={type}
          disabled={disabled}
          error={!!error}
          placeholder={placeholder}
          helperText={error}
          value={value}
          fullWidth
        />
      )}
    </Stack>
  );
};

TextFieldRenderer.propTypes = {};

export default TextFieldRenderer;
